import React, { Component } from 'react'

import s from './Table.scss'

export default class TableHeader extends Component {
  render() {
    return (
      <div className={s.tableHeader}>
        <div className={s.tableRowInner}>{this.props.children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Table/TableHeader.jsx